import React from "react";
import { Link } from "react-router-dom";

const Page404 = () => (
  <div className="text-center">
    <div className="error mx-auto" data-text="404">
      404
    </div>
    <p className="lead text-gray-800 mb-5">Página não encontrada</p>
    <p className="text-gray-500 mb-0">Parece que você achou uma falha na matrix...</p>
    <Link to="/app/home">&larr; Voltar para o início</Link>
  </div>
);

export default Page404;
